import { TCreateUserSettingReqDto, TCreateUserSettingResDto } from "@/api/services/main/user-setting/dtos/create-user-setting.dto";
import { TGetUserSettingResDto } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { TUpdateUserSettingReqDto, TUpdateUserSettingResDto } from "@/api/services/main/user-setting/dtos/update-user-setting.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchUserSettingInfoApi = async (): Promise<TGetUserSettingResDto> => {
  const rs = await clientApi.get<TGetUserSettingResDto>("/user-setting");
  return rs.data;
};

export const useGetUserSettingInfo = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_SETTING.FETCH_DETAIL],
    queryFn: () => fetchUserSettingInfoApi(),
  });
};

export const updateUserSettingApi = async (payload: TUpdateUserSettingReqDto): Promise<TUpdateUserSettingResDto> => {
  const rs = await clientApi.put<TUpdateUserSettingResDto>("/user-setting", payload);
  return rs.data;
};

export const createUserSettingApi = async (payload: TCreateUserSettingReqDto): Promise<TCreateUserSettingResDto> => {
  const rs = await clientApi.post<TCreateUserSettingResDto>("/user-setting", payload);
  return rs.data;
};
